/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Container,
  Divider,
  Grid,
  Skeleton,
  Typography,
} from "@mui/material";
import AppCurrencySelect from "../../../../../components/AppCurrencySelect";
import AppButton from "../../../../../components/AppButton";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filterOutCurrencies, findCurrency, formatNumber } from "../../../../../utils";
import { useTranslation } from "react-i18next";
import {
  ArrowRight,
} from "@mui/icons-material";
import AppDialogHalfScreen from "../../../../../components/AppDialogHalfScreen";
import {
  allowedCurrencies,
  MESSAGE_BAR_TYPES,
} from "../../../../../utils/constants";
import { getFees } from "../../../../../store/api";
import { showMessageBar } from "../../../../../store/actions";
import FeeComponent from "./FeeComponent";

export function SelectOptions({
  active,
  setActive,
  amount,
  cryptoCurrency: selected,
  setCryptoCurrency: updateCurrency
}) {
  const currencies = useSelector(({ currencies }) => currencies.currencies);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const account = useSelector(({ Auth }) => Auth?.account)

  const [feeStructure, setFeeStructure] = useState(null);
  const [feeLoading, setFeeLoading] = useState(false);
  const lastFeeKeyRef = useRef(null);
  const feeTimeoutRef = useRef(null);

  const [open, setOpen] = useState(false);

  const filteredCurrency = useMemo(
    () => filterOutCurrencies(currencies, allowedCurrencies),
    [currencies]
  );

  // Ensure we always have a default selection once currencies load
  useEffect(() => {
    if (!selected && filteredCurrency.length) {
      updateCurrency(filteredCurrency[0]);
    }
  }, [selected, filteredCurrency, updateCurrency]);

  const cryptoCurrency = selected || {};

  const getFeesData = useCallback(async () => {
    if (!cryptoCurrency?.currency || !cryptoCurrency?.network) return;

    setFeeStructure(null); // Reset before fetching
    setFeeLoading(true);
    updateCurrency(cryptoCurrency);
    try {
      const data = await getFees({
        amount,
        cryptoCurrency: cryptoCurrency.currency,
        cryptoNetwork: cryptoCurrency.network,
      });
      setFeeStructure(data.result);
    } catch (err) {
      dispatch(showMessageBar(MESSAGE_BAR_TYPES.ERROR, err));
    } finally {
      setFeeLoading(false);
    }
  }, [cryptoCurrency, amount, dispatch, updateCurrency]);

  // Debounce fee API calls when currency or amount change
  const feeKey = useMemo(
    () =>
      cryptoCurrency?.currency && cryptoCurrency?.network
        ? `${cryptoCurrency.currency}-${cryptoCurrency.network}-${amount}`
        : null,
    [cryptoCurrency, amount]
  );

  useEffect(() => {
    if (!feeKey) return;

    // Skip if we've already fetched for this exact combination
    if (lastFeeKeyRef.current === feeKey) {
      return;
    }
    lastFeeKeyRef.current = feeKey;

    if (feeTimeoutRef.current) {
      clearTimeout(feeTimeoutRef.current);
    }

    feeTimeoutRef.current = setTimeout(() => {
      getFeesData();
    }, 400);

    return () => {
      if (feeTimeoutRef.current) {
        clearTimeout(feeTimeoutRef.current);
      }
    };
  }, [feeKey, getFeesData]);
  const handleOpenFees = () => {
    setOpen(true);
  };
  return (
    <Container disableGutters>
      {/* <ThemeProvider theme={theme}> */}
      {/* <Card sx={{ padding: 1 }}>
            <CardContent> */}
      <Typography marginBottom={1}>
        {t('flow2.title')}
      </Typography>
      <AppCurrencySelect
        cryptoCurrency={cryptoCurrency}
        setCryptoCurrency={updateCurrency}
        currencies={filteredCurrency}
        showExchangeRate={true}
        showNetwork={false}
      />
      <Divider sx={{ marginTop: 2 }} />
      <Grid container columnSpacing={1}>
        <Grid item xs={6}>
          <Typography>{t("Amount Requested")}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography textAlign={"right"}>{formatNumber(amount)} {findCurrency(account)}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t("Amount to Swap")}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography textAlign={"right"}>{formatNumber(amount)} {findCurrency(account)}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Box
            border={1}
            padding={1}
            borderRadius={1}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
            onClick={() => (!feeLoading && feeStructure?.totalFeeUsd ? handleOpenFees() : null)}
            sx={{ cursor: feeLoading ? 'default' : 'pointer' }}
          >
            <Typography>{t('totalFees')}</Typography>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              sx={{ cursor: "pointer" }}
            >
              {feeLoading ? (
                <Skeleton variant="text" width={90} height={20} sx={{ bgcolor: 'rgba(255,255,255,0.15)' }} />
              ) : (
                <>
                  <Typography>{formatNumber(feeStructure?.totalFeeUsd)} {findCurrency(account)}</Typography>
                  {feeStructure?.totalFeeUsd && <ArrowRight sx={{ color: "#F8F8F8" }} />}
                </>
              )}
            </Box>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Typography>{t("AmountReceived")}:</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography textAlign={"right"}>
            {feeLoading ? (
              <Skeleton variant="text" width={110} height={20} sx={{ bgcolor: 'rgba(255,255,255,0.15)', ml: 'auto' }} />
            ) : (
              <>
                {formatNumber(feeStructure?.localEstimatedReceivedAmount)} {findCurrency(account)}
              </>
            )}
          </Typography>
        </Grid>
      </Grid>
      <AppButton
        buttontheme="light"
        title={t("loginPage.continue")}
        disabled={feeLoading || !feeStructure}
        onClick={() => setActive(active + 1)}
      ></AppButton>
      <Typography marginTop={1} textAlign={"center"} color={"#D4D4D8"}>
        {t('flow2.note')}
      </Typography>
      {/* </CardContent>
        </Card> */}
      {/* </ThemeProvider> */}
      <AppDialogHalfScreen show={open} onChangeShow={setOpen}>
        <FeeComponent feeStructure={feeStructure} setOpen={setOpen} />
      </AppDialogHalfScreen>
    </Container>
  );
}

export default React.memo(SelectOptions);
